import moment from "moment";

export const SCHEDULE_DEADLINE_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const SCHEDULE_DATE_FORMAT = "dddd, MMM DD, YYYY";

// Turns a Firebase snapshot of one tournament's schedules into a sorted list of
// entries with parsed start/end moments.
export function parseSchedules(snapshot, dateFormat = SCHEDULE_DATE_FORMAT) {
  const schedules = [];

  snapshot.forEach((childSnapshot) => {
    const data = childSnapshot.val() || {};
    const dateParts = (data.date || "").split("/").map(Number);
    const startParts = (data.start || "").split(":").map(Number);
    const endParts = (data.end || "").split(":").map(Number);
    if (
      dateParts.length < 3 ||
      startParts.length < 2 ||
      dateParts.some(isNaN) ||
      startParts.some(isNaN)
    )
      return;

    const startMoment = moment()
      .year(dateParts[0])
      .month(dateParts[1] - 1)
      .date(dateParts[2])
      .hours(startParts[0])
      .minutes(startParts[1])
      .seconds(0)
      .milliseconds(0);
    if (!startMoment.isValid()) return;

    const endMoment = startMoment.clone();
    if (endParts.length >= 2 && !endParts.some(isNaN)) {
      endMoment
        .hours(endParts[0])
        .minutes(endParts[1])
        .seconds(0)
        .milliseconds(0);
      if (!endMoment.isAfter(startMoment)) endMoment.add(1, "day");
    }

    schedules.push({
      id: childSnapshot.key,
      title: data.title,
      description: data.description,
      start: data.start,
      end: data.end,
      date: startMoment.format(dateFormat),
      dateShort: startMoment.format("MMM DD, YYYY"),
      dateKey: startMoment.format("YYYY-MM-DD"),
      startMoment,
      endMoment,
    });
  });

  schedules.sort((a, b) => a.startMoment.valueOf() - b.startMoment.valueOf());
  return schedules;
}

// Picks what a display should show at `now`: the running session, the next one
// before the day starts, or the last one (already finished) while waiting.
export function pickDisplaySchedule(schedules, now) {
  if (!schedules || !schedules.length) return null;

  let active = null;
  schedules.forEach((schedule) => {
    if (schedule.startMoment.valueOf() <= now) active = schedule;
  });

  if (active) {
    const isTimeOut = now >= active.endMoment.valueOf();
    return { schedule: active, isUpcoming: false, isTimeOut };
  }

  return { schedule: schedules[0], isUpcoming: true, isTimeOut: false };
}

export function nextSchedule(schedules, schedule) {
  if (!schedules || !schedule) return null;
  const index = schedules.indexOf(schedule);
  if (index < 0) return null;
  return schedules[index + 1] || null;
}
